import React, { useEffect } from 'react';

const CoverLetterPrintPreview = () => {
  const html = localStorage.getItem('coverLetterHtml') || '';
  useEffect(() => {
    setTimeout(() => window.print(), 300);
  }, []);
  return (
    <div dangerouslySetInnerHTML={{ __html: html }} />
  );
};

export default CoverLetterPrintPreview;
